
/* ========================================================================
 * DOM-based Routing
 * Based on https://gist.github.com/dotMastaz/cdd4316b80d39547af39
 * ======================================================================== */

var Router = ($, context) => {

  var UTIL = {
    init: function(routes_def) {
      UTIL.routes = routes_def;
      UTIL.loadEvents();
    },
    fire: function(func, args) {
      var namespace = UTIL.routes;
      if (func !== '' && typeof namespace[func] === 'function') {
        namespace[func](args)
      }
    },
    loadEvents: function() {
      // console.log("Load Events", context);
      UTIL.fire('common', context);

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
        UTIL.fire(classnm, context);
      });
    }
  };

  return UTIL;

};

export default Router;